import { useSuspenseQuery } from '@tanstack/react-query';
import { dashboardQueries } from '../queries/dashboardQueries';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { getMonthlyUsage } from '../api/DashboardApi';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { mapMonthlyUsageDTOtoBarChartData } from 'src/common/utils/mapMonthlyUsageDTOtoBarChartData';
import { useTranslation } from 'react-i18next';

type MonthlyUsageDataProps = {
  accountRef: string;
  usageType: UsageTypeValue;
};

export const useMonthlyUsageData = ({ accountRef, usageType }: MonthlyUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getMonthlyUsage>>,
    Error,
    ReturnType<typeof mapMonthlyUsageDTOtoBarChartData>
  >({
    queryKey: dashboardQueries.monthlyUsage({ accountRef, usageType }),
    queryFn: () => setMinimalPromiseTime(getMonthlyUsage({ accountRef, usageType })),
    select: (chartData) => mapMonthlyUsageDTOtoBarChartData(chartData, usageType, t),
  });

  return data;
};
